<template>
<div id="addEdit">
  <el-dialog :title="mode==='detail' ? '对单详情' : '编辑对单'" :visible.sync="visible" width="800px">
    <el-form :model="formData" :rules="rules" ref="form" label-width="100px" size="small">
      <el-form-item label="标题" prop="title">
        <el-input v-model="formData.title" :disabled="mode==='detail'"></el-input>
      </el-form-item>

      <el-form-item label="对单金额" prop="money">
        <span v-if="mode==='detail'">{{ formatIssueOrderMoney(formData.money) }}</span>
        <el-input v-else v-model="formData.money" placeholder="0 表示价格面谈">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-select v-model="formData.status" placeholder="请选择状态" style="width: 100%;" :disabled="mode==='detail'">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="formData.remark" :disabled="mode==='detail'"></el-input>
      </el-form-item>

      <!-- 七种业务共用：紧急程度、标签、证明材料（proof_images 4～21 张） -->
      <template v-if="detail">
        <el-form-item label="紧急程度">
          <el-select
            v-model="formData.urgency_level"
            :disabled="mode==='detail'"
            placeholder="请选择紧急程度"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.urgency_level"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标签">
          <el-select
            v-model="formData.tag_codes"
            multiple
            collapse-tags
            :disabled="mode==='detail'"
            placeholder="请选择标签"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.issue_order_tag"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="证明材料">
          <div class="draggable-list">
            <div
              class="item"
              v-for="(item, index) in formData.proof_images"
              :key="item.file_id || index"
            >
              <template v-if="isImage(item.file_path)">
                <img v-img-url="item.file_path" />
              </template>
              <template v-else>
                <span class="doc-file-wrap">
                  <span class="doc-name">{{ item.file_name || item.real_name || '附件' }}</span>
                  <a v-if="isPdf(item)" :href="item.file_url || item.file_path" target="_blank" rel="noopener noreferrer" class="doc-btn">预览</a>
                  <a :href="item.file_url || item.file_path" :download="item.file_name || item.real_name || '附件'" target="_blank" rel="noopener noreferrer" class="doc-btn">下载</a>
                </span>
              </template>
              <a
                v-if="mode==='edit'"
                href="javascript:void(0);"
                class="delete-btn"
                @click.stop="formData.proof_images.splice(index, 1)"
              >
                <i class="el-icon-close"></i>
              </a>
            </div>
            <div
              v-if="mode==='edit' && formData.proof_images.length < uploadConfig.total"
              class="item img-select"
              @click="openUpload('proof_images')"
            >
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <div v-if="mode==='edit'" class="el-form-item__error" style="position:static;margin-top:4px;">须上传 4～21 张，与 C 端 biz_file_type=proof_images 一致</div>
        </el-form-item>
      </template>

      <!-- 业务明细表单（随 biz_type 变化） -->

      <!-- 我有项目 -->
      <template v-if="detail && detail.biz_type==='project'">
        <el-form-item label="项目名称">
          <el-input v-model="formData.project_name" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="所属行业编码">
          <el-select v-model="formData.industry_code" :disabled="mode==='detail'" placeholder="请选择行业">
            <el-option
              v-for="item in enumOptions.industry"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="融资缺口(元)">
          <el-input v-model="formData.financing_amount" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="融资轮次">
          <el-select
            v-model="formData.financing_round"
            :disabled="mode==='detail'"
            placeholder="请选择融资轮次"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.financing_round"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所在地区">
          <el-cascader
            v-model="formData.asset_region_path"
            :placeholder="assetRegionPlaceholder"
            :options="regionOptions"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            :show-all-levels="true"
            :disabled="mode==='detail'"
            clearable
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="项目亮点">
          <el-input type="textarea" v-model="formData.highlights" :disabled="mode==='detail'"></el-input>
        </el-form-item>
      </template>

      <!-- 资产置换 -->
      <template v-else-if="detail && detail.biz_type==='exchange'">
        <el-form-item label="拟出资产类型">
          <el-select v-model="formData.out_asset_type" :disabled="mode==='detail'" placeholder="请选择资产类型">
            <el-option
              v-for="item in enumOptions.asset_type"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="拟出预估价值(元)">
          <el-input v-model="formData.out_estimate_val" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="拟进资产类型">
          <el-select v-model="formData.target_asset_type" :disabled="mode==='detail'" placeholder="请选择资产类型">
            <el-option
              v-for="item in enumOptions.asset_type"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="差额补齐方式">
          <el-select
            v-model="formData.diff_pay_method"
            :disabled="mode==='detail'"
            placeholder="请选择差额补齐方式"
            style="width: 100%;"
          >
            <el-option
              v-for="item in localEnumOptions.diff_pay_method"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="拟补差价(元)">
          <el-input v-model="formData.diff_amount" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="我有的资产·有形商品">
          <el-select
            v-model="formData.tangible_goods_from"
            multiple
            collapse-tags
            :disabled="mode==='detail'"
            placeholder="请选择"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.tangible_goods"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="我有的资产·无形商品">
          <el-select
            v-model="formData.intangible_goods_from"
            multiple
            collapse-tags
            :disabled="mode==='detail'"
            placeholder="请选择"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.intangible_goods"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="我要换的资产·有形商品">
          <el-select
            v-model="formData.tangible_goods_to"
            multiple
            collapse-tags
            :disabled="mode==='detail'"
            placeholder="请选择"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.tangible_goods"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="我要换的资产·无形商品">
          <el-select
            v-model="formData.intangible_goods_to"
            multiple
            collapse-tags
            :disabled="mode==='detail'"
            placeholder="请选择"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.intangible_goods"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="置换备注">
          <el-input type="textarea" v-model="formData.exchange_remark" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="目标资金所在地">
          <el-cascader
            v-model="formData.asset_region_path"
            :placeholder="assetRegionPlaceholder"
            :options="regionOptions"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            :show-all-levels="true"
            :disabled="mode==='detail'"
            clearable
            style="width: 100%;"
          />
        </el-form-item>
      </template>

      <!-- 我有资金 -->
      <template v-else-if="detail && detail.biz_type==='fund'">
        <el-form-item label="资金总额(元)">
          <el-input v-model="formData.total_amount" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="单笔最低(元)">
          <el-input v-model="formData.invest_min" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="单笔最高(元)">
          <el-input v-model="formData.invest_max" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="所在地区">
          <el-cascader
            v-model="formData.asset_region_path"
            :placeholder="assetRegionPlaceholder"
            :options="regionOptions"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            :show-all-levels="true"
            :disabled="mode==='detail'"
            clearable
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="关注行业">
          <el-select
            v-model="formData.focus_industries"
            multiple
            collapse-tags
            :disabled="mode==='detail'"
            placeholder="请选择关注行业"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.industry"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="投资方式">
          <el-select
            v-model="formData.invest_type"
            :disabled="mode==='detail'"
            placeholder="请选择投资方式"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.invest_type"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="风险承受文本">
          <el-select
            v-model="formData.risk_level_text"
            :disabled="mode==='detail'"
            placeholder="请选择风险承受能力"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.risk_level_text"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="联系人姓名">
          <el-input v-model="formData.fund_contact_name" :disabled="mode==='detail'" placeholder="选填"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="formData.fund_contact_phone" :disabled="mode==='detail'" placeholder="选填"></el-input>
        </el-form-item>
        <el-form-item label="匿名发布">
          <el-switch
            v-model="formData.fund_is_anonymous"
            :disabled="mode==='detail'"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item label="特别说明">
          <el-input type="textarea" v-model="formData.fund_remark" :disabled="mode==='detail'"></el-input>
        </el-form-item>
      </template>

      <!-- 我要变现 -->
      <template v-else-if="detail && detail.biz_type==='cashout'">
        <el-form-item label="资金所在地">
          <el-cascader
            v-model="formData.asset_region_path"
            :placeholder="assetRegionPlaceholder"
            :options="regionOptions"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            :show-all-levels="true"
            :disabled="mode==='detail'"
            clearable
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="资产类别">
          <el-select v-model="formData.asset_category" :disabled="mode==='detail'" placeholder="请选择资产类别">
            <el-option
              v-for="item in enumOptions.asset_category"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="品牌">
          <el-input v-model="formData.brand" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="估算价值(元)">
          <el-input v-model="formData.estimate_value" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="市场参考价(元)">
          <el-input v-model="formData.market_price" :disabled="mode==='detail'" placeholder="选填"></el-input>
        </el-form-item>
        <el-form-item label="立省金额(元)">
          <el-input v-model="formData.saving_amount" :disabled="mode==='detail'" placeholder="选填"></el-input>
        </el-form-item>
        <el-form-item label="资产描述">
          <el-input type="textarea" v-model="formData.asset_desc" :disabled="mode==='detail'"></el-input>
        </el-form-item>
      </template>

      <!-- 收购需求 -->
      <template v-else-if="detail && detail.biz_type==='acquisition'">
        <el-form-item label="目标品类">
          <el-select v-model="formData.target_category" :disabled="mode==='detail'" placeholder="请选择目标品类">
            <el-option
              v-for="item in enumOptions.target_category"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="预算下限(元)">
          <el-input v-model="formData.budget_min" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="预算上限(元)">
          <el-input v-model="formData.budget_max" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="预算档位标签">
          <el-input v-model="formData.budget_range_tag" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="意向地域">
          <el-cascader
            v-model="formData.asset_region_path"
            :placeholder="assetRegionPlaceholder"
            :options="regionOptions"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            :show-all-levels="true"
            :disabled="mode==='detail'"
            clearable
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="意向地域说明">
          <el-input v-model="formData.intent_region" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="资产描述">
          <el-input type="textarea" v-model="formData.asset_desc" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名">
          <el-input v-model="formData.contact_name" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="formData.contact_phone" :disabled="mode==='detail'"></el-input>
        </el-form-item>
      </template>

      <!-- 租赁需求 -->
      <template v-else-if="detail && detail.biz_type==='rent'">
        <el-form-item label="租赁标的类型">
          <el-select v-model="formData.rent_asset_type" :disabled="mode==='detail'" placeholder="请选择租赁标的类型">
            <el-option
              v-for="item in enumOptions.rent_asset_type"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="租赁预算(元)">
          <el-input v-model="formData.rent_budget" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="租赁期限">
          <el-select
            v-model="formData.rent_period"
            :disabled="mode==='detail'"
            placeholder="请选择租赁期限"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.rent_term"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="地域要求">
          <el-cascader
            v-model="formData.asset_region_path"
            :placeholder="assetRegionPlaceholder"
            :options="regionOptions"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            :show-all-levels="true"
            :disabled="mode==='detail'"
            clearable
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="特殊要求">
          <el-input type="textarea" v-model="formData.special_require" :disabled="mode==='detail'"></el-input>
        </el-form-item>
      </template>

      <!-- 借款需求 -->
      <template v-else-if="detail && detail.biz_type==='loan'">
        <el-form-item label="借款金额(元)">
          <el-input v-model="formData.loan_amount" :disabled="mode==='detail'"></el-input>
        </el-form-item>
        <el-form-item label="借款期限">
          <el-select
            v-model="formData.loan_term"
            :disabled="mode==='detail'"
            placeholder="请选择借款期限"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.loan_term"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="资金用途">
          <el-select
            v-model="formData.fund_usage"
            :disabled="mode==='detail'"
            placeholder="请选择资金用途"
            style="width: 100%;"
          >
            <el-option
              v-for="item in enumOptions.loan_usage"
              :key="item.enum_key"
              :label="item.enum_value"
              :value="item.enum_key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="地域要求">
          <el-cascader
            v-model="formData.asset_region_path"
            :placeholder="assetRegionPlaceholder"
            :options="regionOptions"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            :show-all-levels="true"
            :disabled="mode==='detail'"
            clearable
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="抵押物类型">
          <el-select
            v-model="formData.mortgage_type"
            :disabled="mode==='detail'"
            placeholder="请选择抵押物类型"
            style="width: 100%;"
          >
            <el-option
              v-for="item in localEnumOptions.mortgage_type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="信用自评">
          <el-select
            v-model="formData.credit_self_eval"
            :disabled="mode==='detail'"
            placeholder="请选择信用自评"
            style="width: 100%;"
          >
            <el-option
              v-for="item in localEnumOptions.credit_self_eval"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </template>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="mode==='edit'" type="primary" @click="submitSave" :loading="loading">保存</el-button>
    </div>
  </el-dialog>

  <!-- 文件管理弹窗（通用上传组件） -->
  <Upload
    v-if="isUpload"
    :config="uploadConfig"
    @returnImgs="onUploadReturn"
  />
</div>
</template>

<script>
import IssueOrderApi from '@/api/issueorder'
import request from '@/utils/request'
import Upload from '@/components/file/Upload'
import { formatIssueOrderMoney } from '@/utils/issueOrderFormat'
import {
  MAIN_KEY,
  fetchLabelValueOptions,
  FALLBACK_ISSUE_ORDER_STATUS_LIST,
  FALLBACK_DIFF_PAY_METHOD,
  FALLBACK_MORTGAGE_TYPE,
  FALLBACK_CREDIT_SELF_EVAL,
} from '@/utils/sysEnumOptions'

export default {
  name: 'IssueOrderAddEdit',
  props: {
    // 城市下拉列表（父组件传入）
    cityList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      mode: 'detail', // detail | edit
      detail: null,   // 完整详情（含 biz_detail）
      // 上传弹窗控制
      isUpload: false,
      uploadKey: '',
      formData: {
        id: '',
        title: '',
        money: '',
        status: '',
        remark: '',
        // 资金/资产所在地三级联动（部分业务使用）
        asset_region_path: [],
        // project
        project_name: '',
        industry_code: '',
        financing_amount: '',
        financing_round: '',
        highlights: '',
        project_files: [],
        // exchange
        out_asset_type: '',
        out_estimate_val: '',
        target_asset_type: '',
        diff_pay_method: '',
        diff_amount: '',
        exchange_remark: '',
        exchange_files: [],
        tangible_goods_from: [],
        intangible_goods_from: [],
        tangible_goods_to: [],
        intangible_goods_to: [],
        // fund
        total_amount: '',
        invest_min: '',
        invest_max: '',
        focus_industries: [],
        invest_type: '',
        risk_level: '',
        risk_level_text: '',
        fund_remark: '',
        fund_contact_name: '',
        fund_contact_phone: '',
        fund_is_anonymous: 0,
        fund_files: [],
        // cashout
        asset_category: '',
        brand: '',
        estimate_value: '',
        market_price: '',
        saving_amount: '',
        urgency_level: '',
        asset_desc: '',
        cashout_proof: [],
        proof_images: [],
        tag_codes: [],
        // acquisition
        target_category: '',
        intent_region: '',
        budget_min: '',
        budget_max: '',
        budget_range_tag: '',
        contact_name: '',
        contact_phone: '',
        is_anonymous: '',
        // rent
        rent_asset_type: '',
        rent_budget: '',
        rent_period: '',
        special_require: '',
        // loan
        loan_amount: '',
        loan_term: '',
        fund_usage: '',
        mortgage_type: '',
        credit_self_eval: '',
      },
      statusList: [...FALLBACK_ISSUE_ORDER_STATUS_LIST],
      // 省市区三级联动数据
      regionOptions: [],
      // 资金所在地占位提示（无匹配选中值时展示已回填文本）
      assetRegionPlaceholder: '请选择省/市/区',
      // 枚举选项
      enumOptions: {
        industry: [],
        asset_type: [],
        asset_category: [],
        target_category: [],
        rent_asset_type: [],
        financing_round: [],
        rent_term: [],
        loan_term: [],
        loan_usage: [],
        invest_type: [],
        urgency_level: [],
        risk_level_text: [],
        issue_order_tag: [],
        tangible_goods: [],
        intangible_goods: [],
      },
      // 与 sys_enum main_key 对齐，失败时用下方兜底
      localEnumOptions: {
        diff_pay_method: [...FALLBACK_DIFF_PAY_METHOD],
        mortgage_type: [...FALLBACK_MORTGAGE_TYPE],
        credit_self_eval: [...FALLBACK_CREDIT_SELF_EVAL],
      },
      rules: {
        // 标题非必填，城市改为通过地区级联维护
        money: [{
          validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请输入对单金额'))
              return
            }
            const n = Number(value)
            if (Number.isNaN(n)) {
              callback(new Error('请输入有效金额'))
              return
            }
            if (n < 0) {
              callback(new Error('对单金额不能小于0'))
              return
            }
            callback()
          },
          trigger: 'blur',
        }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      }
    }
  },
  components: {
    Upload,
  },
  computed: {
    uploadConfig() {
      return {
        total: 21,
        file_type: 'image',
      }
    },
  },
  methods: {
    formatIssueOrderMoney,
    // 打开弹窗：row 为列表数据，mode 为 detail/edit
    show(row, mode = 'detail') {
      if (!row || !row.id) return
      this.mode = mode
      this.visible = true
      this.loading = true

      const needRegion = !this.regionOptions || this.regionOptions.length === 0
      const detailPromise = IssueOrderApi.detail({ issue_order_id: row.id })
      const regionPromise = needRegion ? this.loadRegionTree() : Promise.resolve()

      Promise.all([detailPromise, regionPromise]).then(([res]) => {
        const detail = res.data.detail || {}
        this.detail = detail

        this.formData.id = detail.id || ''
        this.formData.title = detail.title || ''
        const biz = detail.biz_detail || {}
        // 回填资金/资产所在地（三级联动，仅部分业务使用）
        const regionPath = [
          biz.province_id || '',
          biz.city_id || '',
          biz.region_id || '',
        ].filter(Boolean)
        this.formData.asset_region_path = regionPath
        // 后端金额单位为元，前端直接按元展示
        this.formData.money = this.pickAmount(detail.money)
        this.formData.status = String(detail.status || '')
        this.formData.remark = detail.remark || ''
        // 计算资金所在地占位文本（当组件未能正常选中时，至少展示已回填省市区）
        if (regionPath.length) {
          const text = this.getRegionTextByPath(regionPath)
          this.assetRegionPlaceholder = text || '请选择省/市/区'
        } else {
          this.assetRegionPlaceholder = '请选择省/市/区'
        }

        // 根据 biz_type 回填业务明细
        switch (detail.biz_type) {
          case 'project':
            this.formData.project_name = biz.project_name || ''
            this.formData.industry_code = biz.industry_code || ''
            this.formData.financing_amount = this.pickAmount(biz.financing_amount)
            this.formData.financing_round = biz.financing_round || ''
            this.formData.highlights = biz.highlights || ''
            break
          case 'exchange':
            this.formData.out_asset_type = biz.out_asset_type || ''
            this.formData.out_estimate_val = this.pickAmount(biz.out_estimate_val)
            this.formData.target_asset_type = biz.target_asset_type || ''
            this.formData.diff_pay_method = biz.diff_pay_method || ''
            this.formData.diff_amount = this.pickAmount(biz.diff_amount)
            this.formData.exchange_remark = biz.remark || ''
            this.formData.tangible_goods_from = (biz.tangible_goods_from || '').split(',').filter(Boolean)
            this.formData.intangible_goods_from = (biz.intangible_goods_from || '').split(',').filter(Boolean)
            this.formData.tangible_goods_to = (biz.tangible_goods_to || '').split(',').filter(Boolean)
            this.formData.intangible_goods_to = (biz.intangible_goods_to || '').split(',').filter(Boolean)
            break
          case 'fund':
            this.formData.total_amount = this.pickAmount(biz.total_amount)
            this.formData.invest_min = this.pickAmount(biz.invest_min)
            this.formData.invest_max = this.pickAmount(biz.invest_max)
            this.formData.focus_industries = (biz.focus_industries || '').split(',').filter(Boolean)
            this.formData.invest_type = biz.invest_type || ''
            this.formData.risk_level = biz.risk_level || ''
            this.formData.risk_level_text = biz.risk_level_text || ''
            this.formData.fund_remark = biz.remark || ''
            this.formData.fund_contact_name = biz.contact_name || ''
            this.formData.fund_contact_phone = biz.contact_phone || ''
            this.formData.fund_is_anonymous = Number(biz.is_anonymous) === 1 ? 1 : 0
            break
          case 'cashout':
            this.formData.asset_category = biz.asset_category || ''
            this.formData.brand = biz.brand || ''
            this.formData.estimate_value = this.pickAmount(biz.estimate_value)
            this.formData.market_price = this.pickAmount(biz.market_price)
            this.formData.saving_amount = this.pickAmount(biz.saving_amount)
            this.formData.asset_desc = biz.asset_desc || ''
            break
          case 'acquisition':
            this.formData.target_category = biz.target_category || ''
            this.formData.intent_region = biz.intent_region || ''
            this.formData.budget_min = this.pickAmount(biz.budget_min)
            this.formData.budget_max = this.pickAmount(biz.budget_max)
            this.formData.budget_range_tag = biz.budget_range_tag || ''
            this.formData.contact_name = biz.contact_name || ''
            this.formData.contact_phone = biz.contact_phone || ''
            this.formData.is_anonymous = biz.is_anonymous || ''
            break
          case 'rent':
            this.formData.rent_asset_type = biz.rent_asset_type || ''
            this.formData.rent_budget = this.pickAmount(biz.rent_budget)
            this.formData.rent_period = biz.rent_period || ''
            this.formData.special_require = biz.special_require || ''
            break
          case 'loan':
            this.formData.loan_amount = this.pickAmount(biz.loan_amount)
            this.formData.loan_term = biz.loan_term || ''
            this.formData.fund_usage = biz.fund_usage || ''
            this.formData.mortgage_type = biz.mortgage_type || ''
            this.formData.credit_self_eval = biz.credit_self_eval || ''
            break
        }

        this.formData.proof_images = this.normalizeProofImagesDetail(detail)
        this.formData.tag_codes = (detail.tag_codes || '').split(',').filter(Boolean)
        this.loadIssueOrderTags(detail.biz_type)
        this.formData.urgency_level =
          (detail.urgency_level || '') ||
          (detail.biz_type === 'cashout' && biz.urgency_level ? biz.urgency_level : '') ||
          'normal'

        // 首次打开时加载枚举（含后续新增的 tangible_goods / intangible_goods）
        const needEnums =
          !this.enumOptions.industry.length ||
          !this.enumOptions.tangible_goods.length ||
          !this.enumOptions.intangible_goods.length
        if (needEnums) {
          this.loadEnums()
        }
      }).finally(() => {
        this.loading = false
      })
    },

    // 根据 id 路径获取“省/市/区”中文文本，用于占位符展示
    getRegionTextByPath(path) {
      if (!Array.isArray(path) || !path.length || !this.regionOptions || !this.regionOptions.length) {
        return ''
      }
      let curOptions = this.regionOptions
      const labels = []
      for (const id of path) {
        const node = (curOptions || []).find(item => String(item.id) === String(id))
        if (!node) break
        labels.push(node.name)
        curOptions = node.children || []
      }
      return labels.length ? labels.join(' / ') : ''
    },

    normalizeProofImagesDetail(detail) {
      const files = (detail && detail.files) || {}
      let proofList = []
      if (Array.isArray(files.proof_images)) {
        proofList = proofList.concat(files.proof_images)
      }
      if (Array.isArray(files.cashout_proof)) {
        proofList = proofList.concat(files.cashout_proof)
      }
      if (Array.isArray(files.bp_file)) {
        proofList = proofList.concat(files.bp_file)
      }
      if (Array.isArray(files.plan_file)) {
        proofList = proofList.concat(files.plan_file)
      }
      if (!proofList.length) {
        const groupKeys = Object.keys(files || {})
        if (groupKeys.length === 1) {
          proofList = files[groupKeys[0]] || []
        }
      }
      const seen = new Set()
      const uniq = []
      ;(proofList || []).forEach(item => {
        const id = item.file_id
        if (id && !seen.has(id)) {
          seen.add(id)
          uniq.push(item)
        }
      })
      return uniq.map(item => ({
        file_id: item.file_id,
        file_path: item.file_path || item.file_url,
        file_name: item.file_name || item.real_name || '',
      }))
    },

    // 加载地区树
    loadRegionTree() {
      return request._get('/shop/region.region/tree').then(res => {
        this.regionOptions = res.data.list || []
        return this.regionOptions
      })
    },

    // 加载枚举列表
    loadEnums() {
      Promise.all([
        fetchLabelValueOptions(MAIN_KEY.issueOrderListStatus, { stringValue: true }, FALLBACK_ISSUE_ORDER_STATUS_LIST),
        fetchLabelValueOptions(MAIN_KEY.issueOrderDiffPayMethod, { stringValue: true }, FALLBACK_DIFF_PAY_METHOD),
        fetchLabelValueOptions(MAIN_KEY.issueOrderMortgageType, { stringValue: true }, FALLBACK_MORTGAGE_TYPE),
        fetchLabelValueOptions(MAIN_KEY.issueOrderCreditSelfEval, { stringValue: true }, FALLBACK_CREDIT_SELF_EVAL),
      ]).then(([st, diff, mort, cred]) => {
        this.statusList = st
        this.localEnumOptions = {
          diff_pay_method: diff,
          mortgage_type: mort,
          credit_self_eval: cred,
        }
      }).catch(() => {})

      const tasks = [
        { key: 'industry', main_key: 'industry' },
        { key: 'asset_type', main_key: 'asset_type' },
        { key: 'asset_category', main_key: 'asset_category' },
        { key: 'target_category', main_key: 'target_category' },
        { key: 'rent_asset_type', main_key: 'rent_asset_type' },
        { key: 'financing_round', main_key: 'financing_round' },
        { key: 'rent_term', main_key: 'rent_term' },
        { key: 'loan_term', main_key: 'loan_term' },
        { key: 'loan_usage', main_key: 'loan_usage' },
        { key: 'invest_type', main_key: 'invest_type' },
        { key: 'urgency_level', main_key: 'urgency_level' },
        { key: 'risk_level_text', main_key: 'risk_level_text' },
        { key: 'tangible_goods', main_key: 'tangible_goods' },
        { key: 'intangible_goods', main_key: 'intangible_goods' },
      ]
      tasks.forEach(({ key, main_key }) => {
        request._get('/shop/issueorder.enum/list', { main_key }).then(res => {
          this.enumOptions[key] = res.data.list || []
        })
      })
    },

    // 按对单 biz_type 加载标签（独立配置优先，无配置时后端返回通用 issue_order_tag）
    loadIssueOrderTags(bizType) {
      if (!bizType) {
        this.enumOptions.issue_order_tag = []
        return Promise.resolve()
      }
      return request._get('/shop/issueorder.enum/list', {
        main_key: 'issue_order_tag',
        biz_type: bizType,
      }).then(res => {
        this.enumOptions.issue_order_tag = res.data.list || []
      }).catch(() => {
        this.enumOptions.issue_order_tag = []
      })
    },

    // 金额回填：保留 0，避免 || '' 把 0 当成空
    pickAmount(val) {
      return val != null && val !== '' ? val : ''
    },

    // 统一金额输入，按“元”提交；空值返回 null
    normalizeAmount(val) {
      if (val === '' || val === null || val === undefined) return null
      const n = Number(val)
      if (Number.isNaN(n)) return null
      return Math.round(n * 100) / 100
    },

    submitSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const proofCount = (this.formData.proof_images || []).length
        if (proofCount < 4 || proofCount > 21) {
          this.$message.warning('证明材料须上传 4～21 张')
          return
        }
        this.loading = true

        const [province_id, regionCityId, region_id] = this.formData.asset_region_path || []

        const common = {
          issue_order_id: this.formData.id,
          money: this.normalizeAmount(this.formData.money) || 0,
          province_id,
          region_id,
          remark: this.formData.remark,
        }

        const proofPart = {
          urgency_level: this.formData.urgency_level,
          tag_codes: (this.formData.tag_codes || []).join(','),
          files: (this.formData.proof_images || []).map(item => ({
            biz_file_type: 'proof_images',
            file_id: item.file_id,
          })),
        }

        let apiCall
        let payload = {}

        switch (this.detail.biz_type) {
          case 'project':
            payload = Object.assign({}, common, proofPart, {
              city_id: regionCityId,
              project_name: this.formData.project_name,
              industry_code: this.formData.industry_code,
              financing_amount: this.normalizeAmount(this.formData.financing_amount) || 0,
              financing_round: this.formData.financing_round,
              highlights: this.formData.highlights,
            })
            apiCall = IssueOrderApi.edit
            break
          case 'exchange':
            payload = Object.assign({}, common, proofPart, {
              city_id: regionCityId,
              out_asset_type: this.formData.out_asset_type,
              out_estimate_val: this.normalizeAmount(this.formData.out_estimate_val) || 0,
              target_asset_type: this.formData.target_asset_type,
              diff_pay_method: this.formData.diff_pay_method,
              diff_amount: this.normalizeAmount(this.formData.diff_amount) || 0,
              exchange_remark: this.formData.exchange_remark,
              tangible_goods_from: (this.formData.tangible_goods_from || []).join(','),
              intangible_goods_from: (this.formData.intangible_goods_from || []).join(','),
              tangible_goods_to: (this.formData.tangible_goods_to || []).join(','),
              intangible_goods_to: (this.formData.intangible_goods_to || []).join(','),
            })
            apiCall = IssueOrderApi.edit
            break
          case 'fund':
            payload = Object.assign({}, common, proofPart, {
              city_id: regionCityId,
              total_amount: this.normalizeAmount(this.formData.total_amount) || 0,
              invest_min: this.normalizeAmount(this.formData.invest_min) || 0,
              invest_max: this.normalizeAmount(this.formData.invest_max) || 0,
              focus_industries: (this.formData.focus_industries || []).join(','),
              invest_type: this.formData.invest_type,
              risk_level: this.formData.risk_level,
              risk_level_text: this.formData.risk_level_text,
              fund_remark: this.formData.fund_remark,
              contact_name: this.formData.fund_contact_name,
              contact_phone: this.formData.fund_contact_phone,
              is_anonymous: this.formData.fund_is_anonymous,
            })
            apiCall = IssueOrderApi.edit
            break
          case 'cashout':
            payload = Object.assign({}, common, proofPart, {
              asset_category: this.formData.asset_category,
              brand: this.formData.brand,
              estimate_value: this.normalizeAmount(this.formData.estimate_value) || 0,
              market_price: this.normalizeAmount(this.formData.market_price),
              saving_amount: this.normalizeAmount(this.formData.saving_amount),
              asset_desc: this.formData.asset_desc,
              city_id: regionCityId,
            })
            apiCall = IssueOrderApi.edit
            break
          case 'acquisition':
            payload = Object.assign({}, common, proofPart, {
              city_id: regionCityId,
              target_category: this.formData.target_category,
              intent_region: this.formData.intent_region,
              budget_min: this.normalizeAmount(this.formData.budget_min) || 0,
              budget_max: this.normalizeAmount(this.formData.budget_max),
              budget_range_tag: this.formData.budget_range_tag,
              contact_name: this.formData.contact_name,
              contact_phone: this.formData.contact_phone,
              is_anonymous: this.formData.is_anonymous,
            })
            apiCall = IssueOrderApi.edit
            break
          case 'rent':
            payload = Object.assign({}, common, proofPart, {
              city_id: regionCityId,
              rent_asset_type: this.formData.rent_asset_type,
              rent_budget: this.normalizeAmount(this.formData.rent_budget) || 0,
              rent_period: this.formData.rent_period,
              special_require: this.formData.special_require,
            })
            apiCall = IssueOrderApi.edit
            break
          case 'loan':
            payload = Object.assign({}, common, proofPart, {
              city_id: regionCityId,
              loan_amount: this.normalizeAmount(this.formData.loan_amount) || 0,
              loan_term: this.formData.loan_term,
              fund_usage: this.formData.fund_usage,
              mortgage_type: this.formData.mortgage_type,
              credit_self_eval: this.formData.credit_self_eval,
            })
            apiCall = IssueOrderApi.edit
            break
        }

        if (!apiCall) {
          this.loading = false
          this.$message.error('不支持的业务类型')
          return
        }

        apiCall(payload).then(() => {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.$emit('refresh')
          this.visible = false
        }).finally(() => {
          this.loading = false
        })
      })
    },

    // 打开上传弹窗
    openUpload(key) {
      this.uploadKey = key
      this.isUpload = true
    },

    // 上传组件回调
    onUploadReturn(list) {
      this.isUpload = false
      const key = this.uploadKey
      if (!key || !Array.isArray(list) || !list.length) return

      const current = this.formData[key] || []
      const max = this.uploadConfig.total - current.length
      const append = list.slice(0, max)
      append.forEach(item => {
        current.push({
          file_id: item.file_id,
          file_path: item.file_path,
          file_name: item.file_name || item.real_name || '',
        })
      })
      this.$set(this.formData, key, current)
    },

    // 简单判断是否为图片类型
    isImage(path) {
      if (!path) return false
      const lower = String(path).toLowerCase()
      return /\.(jpe?g|png|gif|webp)$/.test(lower)
    },
    // 判断是否为 PDF（用于显示预览按钮）
    isPdf(item) {
      if (!item) return false
      const p = (item.file_path || item.file_name || item.real_name || '').toLowerCase()
      return p.indexOf('.pdf') !== -1
    },
  }
}
</script>

<style lang="scss" scoped>
.draggable-list {
  display: flex;
  flex-wrap: wrap;
}
.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}
.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}
.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
.draggable-list .item:hover .delete-btn {
  display: block;
}
.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}
.draggable-list .img-select i {
  color: #409eff;
}
.doc-file-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 4px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.doc-file-wrap .doc-name {
  font-size: 12px;
  margin-bottom: 6px;
  word-break: break-all;
  max-height: 2.4em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.doc-file-wrap .doc-btn {
  font-size: 12px;
  color: #409EFF;
  text-decoration: none;
  margin-top: 2px;
}
.doc-file-wrap .doc-btn:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/views/issueorder/issueorder/addEdit.vue